// extracted by mini-css-extract-plugin
export default {"link":"gCNh5tTI87","last":"CdhcPeCaBE"};
    if(module.hot) {
      // 1650537988159
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  